import * as React from 'react';

import { useLiveViewRows } from './useLiveViewRows';

// Straight from the lib: this button is lazy loaded, and the Shared index would pull in the whole bundle
import { pluralize } from '../../../Shared/libs/pluralize';

const LIVE_VIEW_PATH = '/teachers/progress_reports/live_view';

// hidden: load testing (LiveView.shadow?), where the subscription, snapshot
// fetches and broadcasts run as for a real teacher but nothing is shown
const StudentsOnlineNavbarButton = ({ hidden = false }: { hidden?: boolean }) => {
  const { studentCount: count } = useLiveViewRows();

  if (hidden || !count) { return null; }

  return (
    <a className="students-online-navbar-button quill-button outlined small green focus-on-light" href={LIVE_VIEW_PATH}>
      <span aria-hidden="true" className="online-indicator" />
      {count} <span className="students-online-word">{pluralize(count, 'Student', 'Students')} </span>Online
    </a>
  );
};

export default StudentsOnlineNavbarButton;
